import { RepositoryFactory } from '@/http/api/RepositoryFactory'
const MeasurementRepository = RepositoryFactory.get('MeasurementRepository')['MeasurementRepository'];

import { DefaultStoreActions } from '@/store/utils/requests'
const { get } = DefaultStoreActions(MeasurementRepository)

export const STORE_MODULE_NAME = 'measurement';
export const STORE_MODULE_CONFIG =  {
    namespaced: true,
    state: {
        isVerticalMenuActive: false,
    },
    getters: {},
    mutations: {},
    actions: {
        fetch: get,
    },
}
